module.exports = __webpack_public_path__ + "img/B2B_Partnership.e03ebe66.png";